import React from "react";
import { PlanSummaryContainer } from "../../../containers";

const PlanSummary = (props) => {
  return <PlanSummaryContainer {...props} />;
};

export default PlanSummary;
